// extracted by mini-css-extract-plugin
export default {"container":"Fs-z","brandName":"Gs-z","productName":"Hs-z","aboveGalleryInfo":"Is-z","belowGalleryInfo":"Js-z","breakLongProductName":"Ks-z"};